var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "column padding-top-xs padding-bottom-md hero-icon-grid",
      style: _vm.gridStyles,
      on: { click: _vm.navigateToSearchResult },
    },
    _vm._l(_vm.gridConfig.numRows, function (row) {
      return _c(
        "div",
        { key: `${_vm.position}-row-${row}`, style: _vm.rowStyles(row) },
        _vm._l(_vm.gridConfig.numCols, function (col) {
          return _c(
            "div",
            { key: `${_vm.position}-icon-${row}-${col}` },
            [
              _c(
                "transition",
                {
                  attrs: {
                    "enter-active-class":
                      "animate__animated animate__fastest animate__fadeIn",
                    "leave-active-class":
                      "animate__animated animate__fastest animate__fadeOut",
                    mode: "out-in",
                  },
                },
                [
                  _c("i", {
                    key: `${_vm.position}-${row}-${col}-${_vm.iconClassMatrix[
                      row - 1
                    ][col - 1].join("-")}`,
                    class: _vm.iconClassMatrix[row - 1][col - 1],
                    style: _vm.iconStyles(row, col),
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ],
            1
          )
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }